import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { ChargingCardToWallboxFormData } from '../charging-card-to-wallbox-form-data'
import { Stack } from '@mui/material'
import { CheckboxField } from '@e3dc-react/shell/Elements/InputFields'

interface ChargingCardLinkWallboxCellProps {
  control: Control<ChargingCardToWallboxFormData>
  ocpiTokenId: string
  wallboxId: string
  isCheckboxDisabled: boolean
}

/**
 * Component for displaying wallbox inside charging card to link wallboxes table cell
 * This component properly format all values for table cell with checkboxes
 */
export const ChargingCardLinkWallboxCell: React.FC<ChargingCardLinkWallboxCellProps> = ({ control, wallboxId, ocpiTokenId, isCheckboxDisabled }) => {
  return (
    <Controller
      control={control}
      name={`${ocpiTokenId}.${wallboxId}`}
      render={({ field: { value, onChange } }) => {
        return (
          /**
           * Apply minWidth to the cell to make sure each checkbox column has enough space. If wallbox name is short or
           * consists of several short words("My WB 2"), the 'auto' layout of the table will assign the wallbox column as
           * little horizontal space as possible, making checkboxes too close to each other.
           *
           * The exact width 160 is chosen because this is roughly the width of an automatically calculated width of wallbox
           * column with a generic label "EdisonConnect (ID: 0014xxxxxxxxxxxx)" which we expect to be shown the most in the UI.
           */
          <Stack width="100%" minWidth={160}>
            <CheckboxField label="" value={value} disabled={isCheckboxDisabled} onChange={onChange} sx={{ alignSelf: 'start' }} />
          </Stack>
        )
      }}
    />
  )
}
